<template>
    <div>
        <b-tabs>
            <b-tab title="Dados Gerais">
                <div>
                    <b-card>

                        <b-form-row>

                            <lg-form-input disabled v-model="form.itemRegEntrada.produto.descricaoResumida"
                                label="Descrição:" cols="8" />

                            <lg-form-input disabled v-model="form.situacao" label="Status:" cols="4" />


                        </b-form-row>
                        <b-form-row>

                            <lg-form-input disabled v-model="form.numTombamento" label="Nº Tombamento:" cols="3" />
                            <b-col cols="2">
                                <b-button id="localizarHistTomb" class="ml-3 my-2 mt-3" size="sm" style="height: 40px"
                                    pill variant="primary" @click="abrirModalHistorico">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="clock" />
                                    </div>
                                    <b-tooltip target="localizarHistTomb" title="Histórico de Tombamento"></b-tooltip>
                                </b-button>
                            </b-col>

                            <div class="col-3"></div>
                            <lg-form-input disabled v-model="form.s_numTombAntigo" label="Nº Tombamento Samp:"
                                cols="3" />

                            <div class="col-2">
                            </div>

                        </b-form-row>

                        <b-form-row>


                            <lg-form-date description=" " v-model="form.dataTombamentoFormatada"
                                label="Data Tombamento:" cols="8" disabled />

                            <lg-form-date description=" " v-model="form.dataTombamentoAntiga"
                                label="Data Tombamento Samp:" cols="4" disabled />

                        </b-form-row>
                        <b-form-row>
                            <b-form-group disabled label="Bem Relacionável:" class="mb-0 col-8"
                                v-slot="{ ariaDescribedby }">

                                <b-form-radio-group v-model="form.relacionado" :options="[
                                    { text: 'Sim', value: true },
                                    { text: 'Não', value: false }
                                ]" :aria-describedby="ariaDescribedby"></b-form-radio-group>
                            </b-form-group>

                            <lg-form-date class="" description=" " v-model="form.dataEntradaFormatada"
                                label="Data Aquisição:" cols="4" disabled />


                        </b-form-row>
                        <b-form-row>
                            <lg-form-input disabled v-model="form.especificacaoProduto.descricao" label="Especificação:"
                                cols="8" />


                            <lg-form-input disabled v-model="form.valorOriginal" label="Valor Aquisição:" cols="4" />


                        </b-form-row>


                        <b-form-row>
                            <b-col cols="8">
                                <b-form-group label="Descrição Detalhada:">
                                    <textarea disabled v-model="form.descricaoDetalhadaProduto" rows="5"
                                        class="form-control"></textarea>
                                </b-form-group>
                            </b-col>
                            <b-col cols="4" style="margin-left: -14px;">
                                <lg-form-input disabled v-model="form.valor" label="Valor Atual:" cols="12" />
                                <lg-form-date label="Garantia:" description="" v-model="form.dataGarantia" cols="12"
                                    disabled />
                                <lg-form-input label="Status:" disabled v-model="form.status.descricao" cols="12" />
                            </b-col>
                        </b-form-row>


                        <b-form-row>
                            <lg-form-input description=" " disabled v-model="form.numSerie" label="Nº Série:"
                                cols="8" />


                            <lg-form-input description=" " disabled v-model="form.marca.descricao" label="Marca:"
                                cols="4" />


                            <lg-form-input description=" " disabled v-model="form.lote.descricao" label="Nº Lote:"
                                cols="8" />

                            <lg-form-input description=" " disabled v-model="form.modelo.descricao" label="Modelo:"
                                cols="4" />

                        </b-form-row>

                        <b-form-row>
                            <lg-form-input description=" " disabled v-model="form.lotacao.departamento.descricao"
                                label="Unidade Administrativa:"
                                :cols="mostrarBotacaoHistoricoLotacao() ? '11' : '12'" />
                            <b-col cols="1" v-if="mostrarBotacaoHistoricoLotacao()" class="mt-3">
                                <b-button id="localizarHistLotacao" class="ml-3 my-2 mt-3" size="sm"
                                    style="height: 40px" pill variant="primary" @click="abrirModalHistoricoLotacao">
                                    <div class="btn-size-alinhamento">

                                        <b-icon icon="clock" />
                                    </div>
                                    <b-tooltip target="localizarHistLotacao" title="Histórico de Lotações"></b-tooltip>
                                </b-button>
                            </b-col>


                            <lg-form-input description=" " disabled v-model="form.lotacao.departamento.sigla"
                                label="Sigla:" cols="12" />


                            <lg-form-input description=" " disabled v-model="form.localArmazenamento.descricao"
                                label="Localizacao:" cols="8" />

                            <lg-form-input description=" " disabled
                                v-model="form.localArmazenamento.tipoLocalArmazenamento.descricao"
                                label="Tipo Localização:" cols="4" />


                            <lg-form-input description=" " disabled v-model="form.complemento" label="Complemento:"
                                cols="12" />


                            <lg-form-input description=" " disabled v-model="form.lotacao.pessoa.nome"
                                label="Responsável UA:" cols="12" />

                            <lg-form-input description=" " disabled v-model="form.pessoa.nome" label="Utilizado por:"
                                cols="12" />


                            <lg-form-input description=" " disabled v-model="form.pessoaResponsavel.nome"
                                label="Responsável:" cols="12" />

                            <lg-form-input description=" " disabled v-model="form.pessoaCoResponsavel.nome"
                                label="Co Responsável:" cols="12" />



                        </b-form-row>

                    </b-card>
                </div>
            </b-tab>
            <b-tab title="Registro Entrada">
                <RegistroEntradaView :id="this.form.id" v-if="this.form.id"></RegistroEntradaView>
            </b-tab>

        </b-tabs>
        <ModalHistoricoTombamentoList v-if="mostrarModal" :item="this.itemHistorico" :prefix="prefix"
            @fecharModal="fecharModal"></ModalHistoricoTombamentoList>

        <ModalHistoricoLotacaoList v-if="mostrarModalHistoricoLotacao" :item="this.itemHistorico" :prefix="title"
            @fecharModal="fecharModal"></ModalHistoricoLotacaoList>



    </div>
</template>
<script>


import ResourceService from "@/core/api/ResourceService"
import LgFormDate from "@/core/components/Form/LgFormDate.vue"
import LgFormInput from "@/core/components/Form/LgFormInput.vue"
import ModalHistoricoTombamentoList from "@/core/components/Modals/ModalHistoricoTombamentoList.vue"
import ModalHistoricoLotacaoList from "@/core/components/Modals/ModalHistoricoLotacaoList.vue"

import { FormResourceMixin } from "@/core/mixins/resource"
import RegistroEntradaView from "@/modules/almoxarifados/registros-entrada/RegistroEntradaView.vue"

export default {
    components: {
        LgFormInput,
        LgFormDate,
        RegistroEntradaView,
        ModalHistoricoTombamentoList,
        ModalHistoricoLotacaoList
    },
    props: {
        id: Number,
        prefix: { type: [String, Array], default: "" }
    },

    mixins: [FormResourceMixin],


    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"].filter(item => item && item != "");
        },
        title() {
            return this.updatedPrefix.join(" > ")
        },
        fieldsTabelaItens() {
            return [
                {
                    key: "numTombamento",
                    label: " Tombamento",
                    tdClass: "py-0 col-2",
                },
                {
                    key: "s_numTombAntigo",
                    label: "Tombamento Samp",
                    tdClass: "py-0 col-4",
                },
                {
                    key: "itemRegEntrada.produto.numero",
                    label: "Numero",
                    tdClass: "py-0 col-1",
                    formatter: (value) => value || "-",
                },
                {
                    key: "itemRegEntrada.produto.descricaoResumida",
                    label: "Descrição",
                    tdClass: "py-0 col-1",
                    formatter: (value) => value || "-",
                },
                {
                    key: "relacionado",
                    label: "Br",
                    tdClass: "py-0 col-1",
                    formatter: (value) => value || "-",
                },
                {
                    key: "valorOriginal",
                    label: "Valor Aquisição",
                    tdClass: "py-0 col-1",
                },

            ]
        },

    },

    data() {
        return {
            itemHistorico: null,
            mostrarModal: false,
            mostrarModalHistoricoLotacao: false,
            showModal: true,
            form: {
                dataEntradaFormatada: "",
                pessoa: { nome: "" },
                localArmazenamento: { descricao: "", tipoLocalArmazenamento: { descricao: '' } },
                lote: { descricao: "" },
                lotacao: { pessoa: { nome: "" }, departamento: { descricao: '', sigla: '' } },
                itemRegEntrada: { descricao: '', produto: { descricao: '' } },
                tipoAquisicao: { descricao: '' },
                notaFiscal: "",
                vlNotaFiscal: 0,
                nroEmpenho: "",
                empenho: {},
                descricao: "",
                numeroTombamento: "",
                numeroTombamentoSamp: "",
                dataTombamentoFormatada: "",
                dataTombamentoSamp: "",
                dataAquisicao: "",
                especificacaoProduto: { descricao: "" },
                valorAquisicao: "",
                descricaoDetalhadaProduto: "",
                valorAtual: "",
                numeroSerie: "",
                status: { descricao: "" },
                numeroLote: "",
                dataGarantia: "",
                marca: { descricao: "" },
                modelo: { descricao: "" },
                unidadeAdministrativa: "",
                sigla: "",
                localizacao: "",
                complemento: "",
                responsavelUnidadeAdministrativa: "",
                utilizadoPor: "",
                data: new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
            },
            itensFields: [
                { key: "numTombamento", label: " Tombamento" },
                { key: "s_numTombAntigo", label: "Tombamento Samp" },
                { key: "itemRegEntrada.produto.numero", label: "Numero" },
                { key: "itemRegEntrada.produto.descricaoResumida", label: "Descrição" },
                { key: "relacionado", label: "Br" },
                { key: "valorOriginal", label: "Valor Aquisição" },
            ],
        }
    },
    async beforeMount() {
        this.busy = true
        this.$service = new ResourceService(`/api/consultaitembempermanente`)
        this.$service.findById(this.id).then(response => {
            var data = response.data

            data.status = data.status ? data.status : { descricao: '' }
            data.situacao = data.situacao == 1 ? 'Ativo' : 'Inativo'
            data.lote = data.lote ? data.lote : { descricao: '' }
            data.pessoaResponsavel = data.pessoaResponsavel && data.pessoaResponsavel.id ? data.pessoaResponsavel : { nome: "" };

            data.pessoaCoResponsavel = data.pessoaCoResponsavel && data.pessoaCoResponsavel.id ? data.pessoaCoResponsavel : { nome: "" };

            data.especificacaoProduto = data.especificacaoProduto ? data.especificacaoProduto : { descricao: "" }

            if (data.lotacao && data.lotacao.pessoa)
                data.lotacao.pessoa = data.lotacao.pessoa && data.lotacao.pessoa.nome ? data.lotacao.pessoa : { nome: "" }
            else
                data.lotacao = { departamento: { descricao: "" }, pessoa: { nome: "" } };

            data.pessoa = data.pessoa && data.pessoa.nome ? data.pessoa : { nome: "" }
            data.marca = data.marca ? data.marca : { descricao: "" }
            data.modelo = data.modelo ? data.modelo : { descricao: "" }

            if (data.localArmazenamento && data.localArmazenamento.tipoLocalArmazenamento) {
                data.localArmazenamento.tipoLocalArmazenamento = data.localArmazenamento.tipoLocalArmazenamento ? data.localArmazenamento.tipoLocalArmazenamento : { descricao: "" }
            }
            else {
                data.localArmazenamento = { descricao: "", tipoLocalArmazenamento: { id: null, descricao: "" } }
            }
            data.relacionado = data.relacionado == 1 ? true : false
            this.form = data
            this.busy = false

        })

    },


    methods: {
        mostrarBotacaoHistoricoLotacao() {
            return this.form.status.id == 260 || !this.form.bloqueado;
        },
        cancelar() {
            this.$emit("fecharModal")
        },
        fecharModal() {
            this.itemHistorico = null;
            this.mostrarModal = false;
            this.mostrarModalHistoricoLotacao = false;
        },
        abrirModalHistorico() {

            this.itemHistorico = this.form
            this.mostrarModal = true
        },
        abrirModalHistoricoLotacao() {

            this.itemHistorico = this.form
            this.mostrarModalHistoricoLotacao = true
        }
    },
}
</script>
